/** Paths within the resident notification-center route scope; `list` resolves to the scope root. */
export const residentNotificationsRoutes = {
  list: "",
} as const;
